import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectUserActiveEmployerInfo } from 'store/user/selectors.js/user.selectors';
import { createAndUpdateShadowProjectAssignments } from '../services/createAndUpdateShadowProjectAssignments.service';

export const createAndUpdateShadowProjectAssignmentsThunk = createAsyncThunk(
  'shadowData/createAndUpdateShadowProjectAssignments',
  async (
    {
      projectId,
      createdAssignments,
      updatedAssignments,
      isUserModifiedAssignments,
    },
    { getState }
  ) => {
    const activeEmployerInfo = selectUserActiveEmployerInfo(getState());

    const result = await createAndUpdateShadowProjectAssignments(
      projectId,
      createdAssignments,
      updatedAssignments,
      isUserModifiedAssignments,
      activeEmployerInfo
    );

    return result;
  }
);
